import { createReducer, on } from '@ngrx/store';
import {
  GridConfig,
  PaginatedTypeData,
  TypeData,
} from 'src/utils/interfaces/rotor-type.interfaces';
import * as RotorTypeListActions from './rotor-type-list.actions';

export const RotorTypeListStoreName = 'RotorTypeList';

export interface RotorTypeListState {
  rotorType: TypeData;
  typeData: PaginatedTypeData;
  rightPanelTypeData: TypeData;
  gridConfig: GridConfig;
}

export const RotorTypeListStoreInitial: RotorTypeListState = {
  rotorType: null,
  typeData: null,
  rightPanelTypeData: null,
  gridConfig: null,
};

export const rotorTypeListReducer = createReducer(
  RotorTypeListStoreInitial,

  on(RotorTypeListActions.saveRotorType, (state: RotorTypeListState, { rotorType }) => ({
    ...state,
    rotorType,
  })),

  on(RotorTypeListActions.resetRotorType, (state: RotorTypeListState) => ({
    ...state,
    rotorType: null,
  })),

  on(RotorTypeListActions.saveTypeData, (state: RotorTypeListState, { typeData }) => ({
    ...state,
    typeData,
  })),

  on(RotorTypeListActions.saveRightPanelTypeData, (state: RotorTypeListState, { typeData }) => ({
    ...state,
    rightPanelTypeData: typeData,
  })),

  on(RotorTypeListActions.saveGridConfig, (state: RotorTypeListState, gridConfig) => ({
    ...state,
    gridConfig,
  }))
);
